import { render, staticRenderFns } from "./Step9.vue?vue&type=template&id=4557a560&scoped=true&"
import script from "./Step9.vue?vue&type=script&lang=js&"
export * from "./Step9.vue?vue&type=script&lang=js&"
import style0 from "./Step9.vue?vue&type=style&index=0&id=4557a560&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4557a560",
  null
  
)

export default component.exports